import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useSignUp } from '@clerk/clerk-react';
import {
  AUTH_DEBUG_ENABLED,
  logAuthRouteChange,
  logSignUpStateTransition,
  noteEmailVerificationPrepared,
} from '../../auth/authLifecycleDebug';

/**
 * Dev-only: traces signUp resource + route changes during signup/verification.
 * Renders nothing; mount inside Signup page only.
 */
const ClerkSignUpLifecycleProbe = () => {
  const location = useLocation();
  const { isLoaded, signUp } = useSignUp();
  const prevSignUpRef = useRef(null);
  const prevPathRef = useRef(location.pathname);

  useEffect(() => {
    if (!AUTH_DEBUG_ENABLED) return;
    if (prevPathRef.current !== location.pathname) {
      logAuthRouteChange(prevPathRef.current, location.pathname, 'Signup route pathname');
      prevPathRef.current = location.pathname;
    }
  }, [location.pathname]);

  useEffect(() => {
    if (!AUTH_DEBUG_ENABLED || !isLoaded) return;

    logSignUpStateTransition(prevSignUpRef.current, signUp, 'useSignUp');
    noteEmailVerificationPrepared(signUp, 'useSignUp effect');
    prevSignUpRef.current = signUp;
  }, [isLoaded, signUp]);

  return null;
};

export default ClerkSignUpLifecycleProbe;
